// This file was auto-generated by querybuilder/Apollo and should not be edited.

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetEmailVerificationStatus
// ====================================================

export interface GetEmailVerificationStatus_session {
  /**
   * The email of the currently logged-in user, or null if not logged-in. Note that
   * this can be an empty string if the user hasn't yet given us their email.
   */
  email: string | null;
  /**
   * Whether the user's email address has been verified, or null if not logged-in.
   */
  isEmailVerified: boolean | null;
}

export interface GetEmailVerificationStatus {
  session: GetEmailVerificationStatus_session;
}


export const GetEmailVerificationStatus = {
  // The following query was taken from GetEmailVerificationStatus.graphql.
  graphQL: `query GetEmailVerificationStatus {
    session {
        email,
        isEmailVerified
    }
}
`,
  name: "GetEmailVerificationStatus",
  fetch(fetchGraphQL: (query: string, args?: any) => Promise<any>, ): Promise<GetEmailVerificationStatus> {
    return fetchGraphQL(GetEmailVerificationStatus.graphQL);
  },

};

export const fetchGetEmailVerificationStatus = GetEmailVerificationStatus.fetch;